"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Class
class PreviewVideo extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getResource", resource => {
      const mimeType = resource.mimeType,
            url = resource.url;
      return {
        type: mimeType,
        src: url
      };
    });

    _defineProperty(this, "getUrls", () => {
      const media = this.props.formData.media;
      const resources = media.resources;
      const urls = [];

      if (resources['mp4']) {
        urls.push(this.getResource(resources['mp4']));
      }

      if (resources['webm']) {
        urls.push(this.getResource(resources['webm']));
      }

      return urls;
    });
  }

  render() {
    const urls = this.getUrls();
    return _react.default.createElement(_reactPlayer.default, {
      className: "video",
      url: urls,
      controls: true
    });
  }

}

var _default = PreviewVideo;
exports.default = _default;
module.exports = exports.default;